<template>
  <div class="pa-4">
    <v-snackbar
    v-model="snackbarLoading"
    :timeout="0"
    top
    > 
      <div class="c-flex-c1 justify-center align-center">
        <div class="caption">
        LOADING
        </div>
        <v-progress-linear :indeterminate="true" class="mt-1 mb-1"></v-progress-linear>
      </div>
    </v-snackbar>

    <router-link
    class="rlink-hover text--text"
    style="text-decoration: none;"
    :to="{ path: `/production/${id}`}">
      <span class="ml-1">Production id: {{ id }}</span>
    </router-link>

    <v-layout align-end>
      <v-flex xs3 offset-xs6 class="text-xs-right mr-4">
        Production date
      </v-flex>
      <v-flex xs3>
        <div class="answer">
          <input type="text" :value="productionStartDate" style="width: 100%;">
        </div>
        <div class="c-border-b"></div>
      </v-flex>
    </v-layout>
    <v-layout align-end>
      <v-flex xs3 offset-xs6 class="text-xs-right mr-4">
        Customer
      </v-flex>
      <v-flex xs3>
        <div class="answer">
          <input type="text" style="width: 100%;">
        </div>
        <div class="c-border-b"></div>
      </v-flex>
    </v-layout>
    <v-layout align-end>
      <v-flex xs3 offset-xs6 class="text-xs-right mr-4">
        Lab temp
      </v-flex>
      <v-flex xs3>
        <div class="answer">
          <input type="text" style="width: 100%;">
        </div>
        <div class="c-border-b"></div>
      </v-flex>
    </v-layout>
    <v-layout align-end>
      <v-flex xs3 offset-xs6 class="text-xs-right mr-4">
        Fridge temp
      </v-flex>
      <v-flex xs3>
        <div class="answer">
          <input type="text" style="width: 100%;">
        </div>
        <div class="c-border-b"></div>
      </v-flex>
    </v-layout>
    <v-layout align-end>
      <v-flex xs3 offset-xs6 class="text-xs-right mr-4">
        pH
      </v-flex>
      <v-flex xs3>
        <div class="answer">
          <input type="text" style="width: 100%;">
        </div>
        <div class="c-border-b"></div>
      </v-flex>
    </v-layout>

    <div class="headline mt-4 mb-4">
      OUTPUTS
    </div>

    <output-row v-for="output of outputs"
    :key="output.id"
    :item="output">
      {{ output }}
    </output-row>

    <!-- INPUTS -->
    <v-card class="pl-4 pr-4 pt-2 pb-2 elevation-0">
      <v-layout class="headline mt-4 mb-4" wrap>
        <v-flex xs12>
          INPUTS
          <c-preffered-metric-selector :sid.sync="prefferedSid">
          </c-preffered-metric-selector>

          <v-menu offset-y v-if="buildsUsedInInputs.length > 1">
            <template v-slot:activator="{ on }">
              <v-btn
                depressed
                v-on="on"
              >
                <v-row class="align-center">
                  <img src="@/assets/img/illustrations/recipe.png" alt="cardboard box" width="26px">
                  <span class="ml-2">Sort by build</span>
                  <v-icon>mdi-chevron-down</v-icon>
                </v-row>
              </v-btn>
            </template>
            <v-card class="">
              <v-list>
                <v-list-item
                v-for="buildItem of buildsUsedInInputs" :key="buildItem.id"
                @click="build = buildItem">
                  <v-list-item-title :class="[{'color1--text': build.id === buildItem.id}]">
                    {{ buildItem.name }}
                  </v-list-item-title>
                </v-list-item>
              </v-list>
            </v-card>
          </v-menu>
        </v-flex>
      </v-layout>

      <input-row v-for="input of productionInputsRMSorted"
      :key="input.inventory_item_id"
      :item="input"
      :prefferedSid="prefferedSid">
      </input-row>
      
      <v-layout v-if="allRMSHaveWeightRatio"
      align-end
      class="subheading mt-4 mb-2">
        <v-flex xs2 class="font-weight-bold blue--text">

          <!--
          <c-metric-selector
          sid="si-mass-g"
          :realValue="totalWeight"
          alwaysScale
          labelMode
          ></c-metric-selector>
          -->

          <c-ms-ii
          sid="si-mass-g"
          :realValue="totalWeight"
          alwaysScale
          labelMode
          ></c-ms-ii>

        </v-flex>
        <span class="blue--text">
          Total weight
        </span>
      </v-layout>
    </v-card>

    <v-card outlined class="pa-4 mt-4">
      <div class="headline mt-4 mb-4">
        PACKAGING
      </div>
      <input-row v-for="input of productionInputsPKGMerged"
      :key="input.inventory_item_id"
      :item="input">
      </input-row>
    </v-card>

    <div class="mt-4 pb-2">
      <div class="headline mt-4 mb-4">
        WASTE
      </div>
      <v-layout wrap>
        <v-flex v-for="n in 6" 
        :key="n"
        class="pa-1"
        xs6>
          <div class="answer c-flex-r">
            {{ n }}.&nbsp;<input type="text" style="width: 100%;">
          </div>
          <div class="c-border-b"></div>
        </v-flex>
      </v-layout>
    </div>

    <v-layout 
    align-center
    class="headline mt-4 mb-4">
      <span 
      @click="hoverPersonell = !hoverPersonell"
      class="clickable-text">
        PERSONELL INVOLVED IN PRODUCTION
      </span>
      <v-layout v-if="hoverPersonell">
        <v-text-field 
        hide-details
        @click.stop
        v-model.number="personellCount"
        style="max-width: 300px; margin-left: 10px;"
        solo>

        </v-text-field>
      </v-layout>
    </v-layout>
    <v-layout wrap>
      <v-flex v-for="n in personellCount" 
      :key="n"
      class="pa-1"
      xs6>
        <div class="answer c-flex-r">
          {{ n }}.&nbsp;<input type="text" style="width: 100%;">
        </div>
        <div class="c-border-b"></div>
      </v-flex>
    </v-layout>

    <v-layout align-end class="mt-2">
      <v-flex xs3 class="subheading">
        Filling checked by
      </v-flex>
      <v-flex xs6>
        <div class="answer">
          <input type="text" style="width: 100%;">
        </div>
        <div class="c-border-b"></div>
      </v-flex>
    </v-layout>
    <v-layout align-end class="mt-2">
      <v-flex xs3 class="subheading">
        Packaging checked by
      </v-flex>
      <v-flex xs6>
        <div class="answer">
          <input type="text" style="width: 100%;">
        </div>
        <div class="c-border-b"></div>
      </v-flex>
    </v-layout>
    <v-layout align-end class="mt-2">
      <v-flex xs3 class="subheading">
        Approved by
      </v-flex>
      <v-flex xs6>
        <div class="answer">
          <input type="text" style="width: 100%;">
        </div>
        <div class="c-border-b"></div>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import {BigNumber} from 'bignumber.js'
import OutputRow from './components/output-row'
import InputRow from './components/input-row'
import axios from 'axios'
import { mapGetters } from 'vuex'

export default {
  props: ['id'],
  components: {
    OutputRow,
    InputRow
  },
  data () {
    return {
      inputs: [],
      outputs: [],
      production: {},
      personellCount: 4,
      hoverPersonell: false,
      prefferedSid: null,
      snackbarLoading: true,
      build: null,
      buildsUsedInInputs: []
    }
  },
  computed: {
    listOutputsBasedOnRMInputs () {
      var retArray = {}
      for (var item of this.productionInputsRM) {
        var output = this.outputs.find(output => output.id === item.production_output_id)
        retArray[item.production_output_id] = output
      }
      return retArray
    },
    productionStartDate () {
      if (this.$moment.utc(this.production.date_start).isValid()) {
        return this.$moment(this.production.date_start).format('DD MMM YYYY')
      }
      return ''
    },
    productionInputsRM () {
      return this.inputs.filter(item => item.type === 0)
    },
    productionInputsPKG () {
      return this.inputs.filter(item => item.type === 1)
    },
    productionInputsRMMerged () {
      var retDict = {}
      this.productionInputsRM.forEach(item => {
        var pointer = retDict[item.inventory_item_id]
        if (pointer) {
          pointer.quantity += item.quantity
          pointer.batches.push(item)
        } else {
          retDict[item.inventory_item_id] = {
            inventory_item_id: item.inventory_item_id,
            quantity: item.quantity,
            batches: [item],
            internal_code: item.internal_code,
            definition: item.definition
          }
        }
      })
      return Object.values(retDict)
    },
    productionInputsRMSorted () {
      var buildItems = (this.build || {}).items || []
      var orderMap =  buildItems.reduce((a, i) => {
        a[i.inventory_item_id] = i.ordering
        return a
      }, {})
      return this.productionInputsRMMerged.sort((a, b) => {
        var orderingA = orderMap[a.inventory_item_id] || 0
        var orderingB = orderMap[b.inventory_item_id] || 0
        return orderingA - orderingB
      })
    },
    productionInputsPKGMerged () {
      var retDict = {}
      this.productionInputsPKG.forEach(item => {
        var pointer = retDict[item.inventory_item_id]
        if (pointer) {
          pointer.quantity += item.quantity
          pointer.batches.push(item)
        } else {
          retDict[item.inventory_item_id] = {
            inventory_item_id: item.inventory_item_id,
            quantity: item.quantity,
            batches: [item],
            internal_code: item.internal_code,
            definition: item.definition
          }
        }
      })
      return Object.values(retDict)
    },
    allRMSHaveWeightRatio () {
      for (var item of this.productionInputsRMMerged) {
        var definition = item.definition
        if (!this.$crx.metrics.getWeightRatio(definition)) {
          return false
        }
      }
      return true
    },
    totalWeight () {
      var tq = this.productionInputsRMMerged.reduce((a, b) => {
        var definition = b.definition
        if (!definition) {
          return a
        }
        var ratio = this.$crx.metrics.getWeightRatio(definition)
        if (!ratio) {
          return a
        }
        return a.plus(ratio.times(b.quantity))
      }, new BigNumber(0))
      return tq.toNumber()
    }
  },
  created () {
    axios.all([
      this.$axios.get('productions/' + this.id),
      this.$axios.get('productions/' + this.id + '/inputs'),
      this.$axios.get('productions/' + this.id + '/outputs')
    ])
    .then(axios.spread((production, inputs, outputs) => {
      this.production = production.data
      this.inputs = inputs.data.rows
      this.outputs = outputs.data.rows

      var productBuilds = []
      this.outputs.forEach(item => {
        if (item.product_build) {
          productBuilds.push(item.product_build)
        }
      })
      return this.$axios.post('product-builds/get-multiple', productBuilds,
      {headers: {'Content-Type': 'application/json'}})
    }))
    .then(builds_response => {
      console.log(builds_response)
      this.buildsUsedInInputs = Object.values(builds_response.data.map)
      this.build = this.buildsUsedInInputs[0]
    })
    .catch(error => this.$root.$errorSnackbar(error))
    .then(() => this.snackbarLoading = false)
  }
}
</script>

<style scoped lang="scss">
.answer {
  font-weight: bold;
  height: 1.8rem;
  font-size: 1.2rem;
}
.c-border-b {
  border-bottom: 1px solid var(--v-hline-base);
}
.clickable-text {
  cursor: pointer;
  &:hover {
    text-decoration: underline;
  }
}
</style>